export default {
  title: 'Zdobywaj punkty i odbieraj nagrody',
  header: {
    pickup: 'Odbiór za 5 minut',
  },
  recommendations: {
    title: 'Polecane',
  },
  discounts: {
    title: 'Rabaty',
    data: [
      {
        title: '+125 dodatkowych punktów',
        description: 'Oceń nas w Google',
      },
      {
        title: '+{{amount}} rabatu',
        description: '+{{amount}} rabatu przy płatności kodem {{code}}',
      },
    ],
    button: {
      add: '+ Dodaj',
    },
  },
  rewards: {
    title: 'Nagrody i kupony',
    balance: 'Saldo',
    points: 'Punkty',
  },
};
